<template>
    <div class="card-offer" >
        <router-link 
            :to="{name:'content_publish',params:{id:offer.id}}"
            :event="(offer.is_active)?'':'click'"
            class="card-offer-header">
            <img :src="imgPreview" :class="{ 'inactive': !this.offer.is_active }" />
        </router-link>
        <div class="card-offer-body">
            <div class="card-offer-dates" v-if="offer.init_date&&offer.end_date">
                <span>{{ formatDate(offer.init_date) }}</span>
                <img src="@/assets/icons/arrow-right.svg" alt="">
                <span class="expires">{{ formatDate(offer.end_date) }}</span>
            </div>
            <div style="height: 24px" v-else></div>
            <div class="card-offer-title">
                {{ offer.title }}
            </div>
            <div class="card-offer-categories">
                <span v-for="cat in offer.category" :key="cat.id">{{ cat.name }}</span>
            </div>
            <div class="card-offer-description">
                {{ offer.description}}
            </div>
        </div>
        <div class="card-offer-actions">
            <div class="card-offer-icons">
                <router-link :to="{name:'content_detail',params:{id:offer.id}}">
                    <img src="@/assets/icons/ico-edit.svg" />
                </router-link>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'

export default {
    name : "offer-card",
    props: ['offer'],
    methods: {
        formatDate: function(date){
            return moment(date).locale('es').format('DD / MMM / YYYY')
        },
        offerIsActive: function(){
            this.patchOffer(this.offer)
                .then(r => {
                    this.offer.is_active = !this.offer.is_active;
                })
                .catch(err => {
                    console.log(err)
                })
        },
        ...mapActions('offers', {
            'patchOffer': 'patchOffer'
        })
    },
    computed: {
        imgPreview: function(){
            return process.env.VUE_APP_CORE_HOST + this.offer.images
        },
        ...mapGetters('offers',{
            'getOffer': 'getOffer'
        })
    }
}
</script>

<style lang="sass">
.card-offer
    width: 100%
    background: #ffffff
    border-radius: 4px
    border: solid 1px #e5edf4

.card-offer-header
    display: block
    width: 100%
    height: 92px
    border-top-left-radius: 4px
    border-top-right-radius: 4px
    overflow: hidden

.card-offer-header img
    width: 100%
    position: relative
    top: 50%
    transform: translateY(-50%)

.card-offer-header img.inactive
    -webkit-filter: grayscale(100%)
    filter: greyscale(100%)

.card-offer-dates
    height: 16px
    width: calc(100% - 16px)
    margin: 8px 8px 0
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    text-align: left

.card-offer-dates span
    font-size: 12px
    font-weight: 300
    font-family: Muli
    color: #302f2f

.card-offer-dates span.expires
    color: #c90b2f

.card-offer-categories span
    font-family: Muli
    font-size: 14px
    color: #ffffff
    display: inline-block
    margin: 4px
    padding: 0 4px
    background-color: #0b99d8
    border-radius: 4px

.card-offer-dates img
    margin: 0 8px
    height: 10px

.card-offer h2
    color: $secondary

.card-offer-body
    color: $secondary

.card-offer-title
    height: 18px
    font-family: Montserrat
    font-size: 14px
    font-weight: 600
    color: #302f2f
    white-space: nowrap
    overflow: hidden
    text-overflow: ellipsis
    text-align: left
    padding-left: 8px
    margin-top: 4px

.card-offer-description
    font-family: Muli
    font-size: 12px
    font-weight: 300
    color: #302f2f
    text-align: left
    padding: 0px 0px 0px 8px
    overflow: hidden
    text-overflow: ellipsis
    display: -webkit-box
    -webkit-line-clamp: 1
    -webkit-box-orient: vertical

.card-offer-actions
    padding-top: 5px
    // height: 40px

.card-offer-switch
    float: left
    display: inline-block
    padding-top: 10px
    padding-left: 5px

.card-offer-visible
    float: left
    display: inline-block
    margin-top: 10px
    margin-left: 5px
    width: 34px
    height: 16px
    border-radius: 12px
    border: solid 1px #3f046d
    background-color: #00c2b0
    cursor: pointer
    transition: all ease 600ms

.card-offer-visible.inactive
    background-color: #dad6de

.card-offer-visible div
    width: 16px
    height: 16px
    box-shadow: 0 0 3px 0 rgba(118, 109, 148, 0.53)
    border: solid 1px #3f046d
    background-color: #ffffff
    border-radius: 50%
    margin-top: -1px
    margin-left: 17px
    transition: all ease 600ms

.card-offer-visible div.inactive
    margin-left: -1px

.card-offer-icons
    padding-right: 5px
    float: right
    display: inline-block

</style>
